<template>
    <div>
        <b-form-group label="Jenis Emas">
            <b-row no-gutters>
                <b-col>
                    <multiselect name="jenisEmas" v-model="input.jenisEmas"
                        :disabled="optJenisEmas.length == 0"
                        :options="optJenisEmas" :internal-search="true" :allow-empty="false"
                        deselect-label="" select-label="" label="name" track-by="name"
                        placeholder="-- Please select an option --" />
                </b-col>
                <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ? false : true">
                    <b-badge :variant="pdfReadJenis == false ? 'danger' : 'primary'"
                        :hidden="seJenis == null ? true : false" size="sm"
                        @click="$emit('openModalSE', seJenis, 'jenis', pdfReadJenis)"
                        v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                        <i class="fa fa-info px-1"></i>
                    </b-badge>
                </b-col>
            </b-row>
        </b-form-group>
    </div>
</template>

<script>
export default {
    props: {
        input: { required: true },
        optJenisEmas: { required: true },
        pdfReadJenis: { required: true },
        seJenis: { required: true },
    },
}
</script>